/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { Progress, Form } from 'antd';
import classNames from 'classnames';
import moment from 'moment';
import { Fragment, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import StepWizard from 'react-step-wizard';
import IconBack from '../../../assets/Images/icons/icon-back';
import ModalDiscardChanges from '../../../components/Shared/modal/discardChanges';
import { ROUTER } from '../../../constants/router';
import useNotify from '../../../context/Notification/useNotify';
import DCDPOService from '../../../services/DCDPO.service';
import { useBlocker } from '../../../util/usePrompt';

import Step1 from './component/Step1';
import Step2 from './component/Step2';
import Step3 from './component/Step3';
import Step4 from './component/Step4';
import Step5 from './component/Step5';
import Step6 from './component/Step6';
import Step7 from './component/Step7';
import Step8 from './component/Step8';
import StepList from './component/StepList';
import StepPreview from './component/StepPreview';
import VendorPolicyService from '../../../services/VendorPolicy.service';
import GlobalService from '../../../services/Global.service';
import { POLICY_NAME } from '../POLICY';

const { Provider } = Form;

export default function VendorDetail() {
    const { t, i18n } = useTranslation();
    const lang = i18n.language;
    let navigate = useNavigate();
    const location = useLocation();
    const { id } = useParams();
    const notify = useNotify();

    const [data] = useState([
        { name: 'Define the policy name and organization information', key: 1 },
        { name: 'Introduction and Lawful Basis', key: 2 },
        { name: 'Personal Data Collected and Source', key: 3 },
        { name: 'Reason for collected data', key: 4 },
        { name: 'Who we will disclose or transfer personal data', key: 5 },
        { name: 'How long and how we retain personal data?', key: 6 },
        { name: 'Data Subject Rights', key: 7 },
        { name: 'Policy change and contact channels', key: 8 },
    ]);

    const [state, updateState] = useState();
    const [applications, setApplications] = useState([]);

    const [currentSelectList, setCurrentSelectList] = useState(1);
    const [loading, setLoading] = useState(false);
    const [loading_, setLoadingSave] = useState(false);
    const [fixed, setFixed] = useState(false);
    const [editData, setEditData] = useState();
    const [editMode] = useState(false);
    const [dsType, setDsType] = useState([]);

    // check validations
    const [step1, setStep1] = useState(false);
    const [step2, setStep2] = useState(false);
    const [step3, setStep3] = useState(false);
    const [step4, setStep4] = useState(false);
    const [step5, setStep5] = useState(false);
    const [step6, setStep6] = useState(false);
    const [step7, setStep7] = useState(false);
    const [step8, setStep8] = useState(false);

    // form
    const [vendorPrivacyPolicy] = Form.useForm();
    const [vendorIntroductionLawfulBasis] = Form.useForm();
    const [vendorPersonalDataCollect] = Form.useForm();
    const [vendorReasonCollectedData] = Form.useForm();
    const [vendorTransferPersonalData] = Form.useForm();
    const [vendorRetainPersonalData] = Form.useForm();
    const [vendorDataSubjectRight] = Form.useForm();
    const [vendorPolicyChange] = Form.useForm();
    const [preview] = Form.useForm();

    const [submitData, setSubmitData] = useState({});

    //Discard change
    const [change, setChange] = useState(false);
    const [openChange, setOpenChange] = useState(false);
    const [nextLocation, setNextLocation] = useState(null);
    const [isChangeLocation, setIsChangeLocation] = useState(false);

    useBlocker((nextLocation) => onChangePage(nextLocation), change);

    const onChangePage = (nextLocation) => {
        setOpenChange(true);
        setIsChangeLocation(true);
        setNextLocation(nextLocation);
    };

    const handelOk = () => {
        setOpenChange(false);
        setChange(false);
    };

    const handelOkLocation = async () => {
        await setOpenChange(false);
        await setChange(false);
        await setIsChangeLocation(false);
        await navigate(
            nextLocation.location.pathname + nextLocation.location.search
        );
    };

    const onFormChange = (_, info) => {
        if (info.changedFields.length > 0) {
            setChange(true);
        }
    };

    const onFormFinish = async (name, info) => {
        const values = info?.values;
        const dsTypeList = [];
        vendorPrivacyPolicy
            ?.getFieldValue('vendorPrivacyPolicyDataSubjectType')
            ?.forEach((val) => {
                const item = dsType?.filter((res) => res?.value === val)[0];
                const privacyId =
                    editData?.vendorPrivacyPolicy?.vendorPrivacyPolicyDataSubjectType?.find(
                        (res) => res?.vendorDataSubjectId === val
                    )?.vendorDataSubjectId;
                dsTypeList?.push({
                    vendorPrivacyPolicyDataSubjectTypeId: privacyId,
                    vendorDataSubjectId: item?.value,
                    vendorDataSubjectNameTh: item?.title,
                    vendorDataSubjectNameEn: item?.title,
                });
            });
        const form = {
            vendorPrivacyPolicy: {
                ...vendorPrivacyPolicy?.getFieldsValue(),
                vendorPrivacyPolicyId: id === 'new' ? undefined : id,
                vendorPrivacyPolicyDataSubjectType: dsTypeList,
                vendorEffectiveDate: vendorPrivacyPolicy?.getFieldValue(
                    'vendorEffectiveDate'
                )
                    ? vendorPrivacyPolicy
                          ?.getFieldValue('vendorEffectiveDate')
                          ?.format('YYYY-MM-DDT00:00:00.000+00:00')
                    : '',
                isPublish: true,
            },
            vendorIntroductionLawfulBasis: {
                ...vendorIntroductionLawfulBasis?.getFieldsValue(),
                vendorIntroductionLawfulBasisId:
                    editData?.vendorIntroductionLawfulBasis
                        ?.vendorIntroductionLawfulBasisId,
                vendorIntroductionIsDisplay:
                    values?.vendorIntroductionIsDisplay,
                vendorLawfulBasisIsDisplay: values?.vendorLawfulBasisIsDisplay,
            },
            vendorPersonalDataCollect: {
                ...vendorPersonalDataCollect?.getFieldsValue(),
                vendorPersonalDataCollectId:
                    editData?.vendorPersonalDataCollect
                        ?.vendorPersonalDataCollectId,
                vendorPersonalDataIsDisplay:
                    values?.vendorPersonalDataIsDisplay,
                vendorSourceIsDisplay: values?.vendorSourceIsDisplay,
            },
            vendorReasonCollectedData: {
                ...vendorReasonCollectedData?.getFieldsValue(),
                vendorReasonCollectedDataId:
                    editData?.vendorReasonCollectedData
                        ?.vendorReasonCollectedDataId,
                vendorPurposeIsDisplay: values?.vendorPurposeIsDisplay,
            },
            vendorTransferPersonalData: {
                ...vendorTransferPersonalData?.getFieldsValue(),
                vendorTransferPersonalDataId:
                    editData?.vendorTransferPersonalData
                        ?.vendorReasonCollectedDataId,
                vendorDisclosureIsDisplay: values?.vendorDisclosureIsDisplay,
                vendorInternationalIsDisplay:
                    values?.vendorInternationalIsDisplay,
            },
            vendorRetainPersonalData: {
                ...vendorRetainPersonalData?.getFieldsValue(),
                vendorRetainPersonalDataId:
                    editData?.vendorRetainPersonalData
                        ?.vendorRetainPersonalDataId,
                vendorRetentionIsDisplay: values?.vendorRetentionIsDisplay,
                vendorSecurityIsDisplay: values?.vendorSecurityIsDisplay,
            },
            vendorDataSubjectRight: {
                ...vendorDataSubjectRight?.getFieldsValue(),
                vendorDataSubjectRightId:
                    editData?.vendorDataSubjectRight?.vendorDataSubjectRightId,
                vendorDataSubjectRightIsDisplay:
                    values?.vendorDataSubjectRightIsDisplay,
            },
            vendorPolicyChange: {
                ...vendorPolicyChange?.getFieldsValue(),
                vendorPolicyChangeId:
                    editData?.vendorPolicyChange?.vendorPolicyChangeId,
                vendorChangeIsDisplay: values?.vendorChangeIsDisplay,
                vendorDataControllerIsDisplay:
                    values?.vendorDataControllerIsDisplay,
                vendorDataProtectionIsDisplay:
                    values?.vendorDataProtectionIsDisplay,
            },
        };
        try {
            setChange(false);
            setOpenChange(false);
            setLoadingSave(true);
            const { data } = await VendorPolicyService.saveVendorPolicy(form);
            if (data?.resultCode === 1) {
                notify({
                    title: t('common.Success'),
                    description: t('Successfully saved data'),
                });
                navigate(
                    `${ROUTER.POLICY.DEFAULT}?tab=${POLICY_NAME.VENDOR_POLICY}`
                );
            } else {
                notify({
                    type: 'error',
                    title: t('common.Fail'),
                    description: t('common.FailedSaveData'),
                });
            }
        } catch (error) {
            notify({
                type: 'error',
                title: t('common.Fail'),
                description: t('common.FailedSaveData'),
            });
        }
    };

    useEffect(() => {
        const current = location.hash.replace('#step', '');
        if (current) {
            setCurrentSelectList(Number(current));
        }
        if (current === '9') {
            setFixed(false);
        }
    }, [location]);

    const setInstance = (SW) =>
        updateState({
            ...state,
            SW,
        });

    const passStep =
        step1 & step2 & step3 & step4 & step5 & step6 & step7 & step8;
    const filter = [
        step1,
        step2,
        step3,
        step4,
        step5,
        step6,
        step7,
        step8,
    ].filter(Boolean).length;
    const currentProgress = ((filter * 100) / 8).toFixed(0);

    const getVendorDetail = async (id) => {
        try {
            setLoading(true);
            const { data } = await VendorPolicyService.getVendorPolicyDetail(
                id
            );
            const res = data?.resultData;
            const dateItem =
                res?.vendorPrivacyPolicy?.effectiveDate?.split(' ');
            const day = dateItem[0]?.split('/')[0];
            const month = dateItem[0]?.split('/')[1];
            const year = dateItem[0]?.split('/')[2];
            const effDate = new Date(
                `${year}-${month}-${day}T${dateItem[1]}:00.000Z`
            );
            setEditData({
                vendorPrivacyPolicy: {
                    ...res?.vendorPrivacyPolicy,
                    vendorEffectiveDate: res?.vendorPrivacyPolicy?.effectiveDate
                        ? moment(effDate)
                        : null,
                },
                vendorIntroductionLawfulBasis: {
                    ...res?.vendorIntroductionLawfulBasis,
                },
                vendorPersonalDataCollect: {
                    ...res?.vendorPersonalDataCollect,
                },
                vendorReasonCollectedData: {
                    ...res?.vendorReasonCollectedData,
                },
                vendorTransferPersonalData: {
                    ...res?.vendorTransferPersonalData,
                },
                vendorRetainPersonalData: {
                    ...res?.vendorRetainPersonalData,
                },
                vendorDataSubjectRight: {
                    ...res?.vendorDataSubjectRight,
                },
                vendorPolicyChange: {
                    ...res?.vendorPolicyChange,
                },
            });
            const dsTypeId = [];
            res?.vendorPrivacyPolicy?.vendorPrivacyPolicyDataSubjectType?.forEach(
                (val) => {
                    dsTypeId?.push(val?.vendorDataSubjectId);
                }
            );
            vendorDataSubjectRight?.setFieldsValue({
                ...res?.vendorDataSubjectRight,
            });
            vendorIntroductionLawfulBasis?.setFieldsValue({
                ...res?.vendorIntroductionLawfulBasis,
            });
            vendorPersonalDataCollect?.setFieldsValue({
                ...res?.vendorPersonalDataCollect,
            });
            vendorPolicyChange?.setFieldsValue({
                ...res?.vendorPolicyChange,
            });
            vendorPrivacyPolicy?.setFieldsValue({
                ...res?.vendorPrivacyPolicy,
                vendorPrivacyPolicyDataSubjectType: dsTypeId,
                vendorEffectiveDate: res?.vendorPrivacyPolicy?.effectiveDate
                    ? moment(effDate)
                    : null,
            });
            vendorReasonCollectedData?.setFieldsValue({
                ...res?.vendorReasonCollectedData,
            });
            vendorRetainPersonalData?.setFieldsValue({
                ...res?.vendorRetainPersonalData,
            });
            vendorTransferPersonalData?.setFieldsValue({
                ...res?.vendorTransferPersonalData,
            });
            preview?.setFieldsValue({
                vendorChangeIsDisplay:
                    res?.vendorPolicyChange?.vendorChangeIsDisplay,
                vendorDataControllerIsDisplay:
                    res?.vendorPolicyChange?.vendorDataControllerIsDisplay,
                vendorDataProtectionIsDisplay:
                    res?.vendorPolicyChange?.vendorDataProtectionIsDisplay,
                vendorDataSubjectRightIsDisplay:
                    res?.vendorDataSubjectRight
                        ?.vendorDataSubjectRightIsDisplay,
                vendorDisclosureIsDisplay:
                    res?.vendorTransferPersonalData?.vendorDisclosureIsDisplay,
                vendorInternationalIsDisplay:
                    res?.vendorTransferPersonalData
                        ?.vendorInternationalIsDisplay,
                vendorIntroductionIsDisplay:
                    res?.vendorIntroductionLawfulBasis
                        ?.vendorIntroductionIsDisplay,
                vendorLawfulBasisIsDisplay:
                    res?.vendorIntroductionLawfulBasis
                        ?.vendorLawfulBasisIsDisplay,
                vendorPersonalDataIsDisplay:
                    res?.vendorPersonalDataCollect?.vendorPersonalDataIsDisplay,
                vendorPurposeIsDisplay:
                    res?.vendorReasonCollectedData?.vendorPurposeIsDisplay,
                vendorRetentionIsDisplay:
                    res?.vendorRetainPersonalData?.vendorRetentionIsDisplay,
                vendorSecurityIsDisplay:
                    res?.vendorRetainPersonalData?.vendorSecurityIsDisplay,
                vendorSourceIsDisplay:
                    res?.vendorPersonalDataCollect?.vendorSourceIsDisplay,
            });
            setSubmitData({
                vendorPrivacyPolicy: {
                    ...res?.vendorPrivacyPolicy,
                    vendorEffectiveDate:
                        res?.vendorPrivacyPolicy?.effectiveDate?.split(' ')[0],
                },
                vendorIntroductionLawfulBasis: {
                    ...res?.vendorIntroductionLawfulBasis,
                },
                vendorPersonalDataCollect: {
                    ...res?.vendorPersonalDataCollect,
                },
                vendorReasonCollectedData: {
                    ...res?.vendorReasonCollectedData,
                },
                vendorTransferPersonalData: {
                    ...res?.vendorTransferPersonalData,
                },
                vendorRetainPersonalData: {
                    ...res?.vendorRetainPersonalData,
                },
                vendorDataSubjectRight: {
                    ...res?.vendorDataSubjectRight,
                },
                vendorPolicyChange: {
                    ...res?.vendorPolicyChange,
                },
            });

            setOpenChange(false);
            setChange(false);
            setLoading(false);
        } catch (error) {
            console.log(error);
        }
    };

    const getDsTypeDropdown = async () => {
        try {
            const { data } = await GlobalService.getDs();
            if (data?.resultData) {
                let option = [];
                data?.resultData?.dataSubjectType?.forEach((element) => {
                    option.push({
                        title: lang === 'en' ? element.nameEn : element?.nameTh,
                        value: element?.id,
                    });
                });
                setDsType(option);
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        getDsTypeDropdown();
        if (id !== 'new') getVendorDetail(id);
        else getDCDPO();
    }, [id]);

    const getDCDPO = async () => {
        try {
            const { data } = await DCDPOService.getDCDPO();
            const item = data?.resultData;
            if (item) {
                vendorPolicyChange.setFieldsValue({
                    vendorDataControllerContentTh: `${item?.nameDPOTh}</br>${item?.addressTh}`,
                    vendorDataControllerContentEn: `${item?.nameDPOEn}</br>${item?.addressEn}`,
                    vendorDataProtectionContentTh: `${item?.staffNameDPOTh}`,
                    vendorDataProtectionContentEn: `${item?.staffNameDPOTh}`,
                });
                setChange(false);
                setOpenChange(false);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const saveDraft = async (e) => {
        try {
            const display = preview?.getFieldsValue();
            const dsTypeList = [];
            vendorPrivacyPolicy
                ?.getFieldValue('vendorPrivacyPolicyDataSubjectType')
                ?.forEach((val) => {
                    const item = dsType?.filter((res) => res?.value === val)[0];
                    const privacyId =
                        editData?.vendorPrivacyPolicy?.vendorPrivacyPolicyDataSubjectType?.find(
                            (res) => res?.vendorDataSubjectId === val
                        )?.vendorDataSubjectId;
                    dsTypeList?.push({
                        vendorPrivacyPolicyDataSubjectTypeId: privacyId,
                        vendorDataSubjectId: item?.value,
                        vendorDataSubjectNameTh: item?.title,
                        vendorDataSubjectNameEn: item?.title,
                    });
                });
            const form = {
                vendorPrivacyPolicy: {
                    ...vendorPrivacyPolicy?.getFieldsValue(),
                    vendorPrivacyPolicyId: id === 'new' ? undefined : id,
                    vendorPrivacyPolicyDataSubjectType: dsTypeList,
                    vendorEffectiveDate: vendorPrivacyPolicy?.getFieldValue(
                        'vendorEffectiveDate'
                    )
                        ? vendorPrivacyPolicy
                              ?.getFieldValue('vendorEffectiveDate')
                              ?.format('YYYY-MM-DDT00:00:00.000+00:00')
                        : '',
                    isPublish: false,
                },
                vendorIntroductionLawfulBasis: {
                    ...vendorIntroductionLawfulBasis?.getFieldsValue(),
                    vendorIntroductionLawfulBasisId:
                        editData?.vendorIntroductionLawfulBasis
                            ?.vendorIntroductionLawfulBasisId,
                    vendorIntroductionIsDisplay:
                        display?.vendorIntroductionIsDisplay,
                    vendorLawfulBasisIsDisplay:
                        display?.vendorLawfulBasisIsDisplay,
                },
                vendorPersonalDataCollect: {
                    ...vendorPersonalDataCollect?.getFieldsValue(),
                    vendorPersonalDataCollectId:
                        editData?.vendorPersonalDataCollect
                            ?.vendorPersonalDataCollectId,
                    vendorPersonalDataIsDisplay:
                        display?.vendorPersonalDataIsDisplay,
                    vendorSourceIsDisplay: display?.vendorSourceIsDisplay,
                },
                vendorReasonCollectedData: {
                    ...vendorReasonCollectedData?.getFieldsValue(),
                    vendorReasonCollectedDataId:
                        editData?.vendorReasonCollectedData
                            ?.vendorReasonCollectedDataId,
                    vendorPurposeIsDisplay: display?.vendorPurposeIsDisplay,
                },
                vendorTransferPersonalData: {
                    ...vendorTransferPersonalData?.getFieldsValue(),
                    vendorTransferPersonalDataId:
                        editData?.vendorTransferPersonalData
                            ?.vendorReasonCollectedDataId,
                    vendorDisclosureIsDisplay:
                        display?.vendorDisclosureIsDisplay,
                    vendorInternationalIsDisplay:
                        display?.vendorInternationalIsDisplay,
                },
                vendorRetainPersonalData: {
                    ...vendorRetainPersonalData?.getFieldsValue(),
                    vendorRetainPersonalDataId:
                        editData?.vendorRetainPersonalData
                            ?.vendorRetainPersonalDataId,
                    vendorRetentionIsDisplay: display?.vendorRetentionIsDisplay,
                    vendorSecurityIsDisplay: display?.vendorSecurityIsDisplay,
                },
                vendorDataSubjectRight: {
                    ...vendorDataSubjectRight?.getFieldsValue(),
                    vendorDataSubjectRightId:
                        editData?.vendorDataSubjectRight
                            ?.vendorDataSubjectRightId,
                    vendorDataSubjectRightIsDisplay:
                        display?.vendorDataSubjectRightIsDisplay,
                },
                vendorPolicyChange: {
                    ...vendorPolicyChange?.getFieldsValue(),
                    vendorPolicyChangeId:
                        editData?.vendorPolicyChange?.vendorPolicyChangeId,
                    vendorChangeIsDisplay: display?.vendorChangeIsDisplay,
                    vendorDataControllerIsDisplay:
                        display?.vendorDataControllerIsDisplay,
                    vendorDataProtectionIsDisplay:
                        display?.vendorDataProtectionIsDisplay,
                },
            };
            setChange(false);
            setOpenChange(false);
            const { data } = await VendorPolicyService.saveVendorPolicy(form);
            if (data?.resultCode === 1) {
                notify({
                    title: t('common.Success'),
                    description: t('Successfully saved data'),
                });
                const vendorPolicyId = data?.resultData?.vendorPrivacyPolicyId;
                const fullPath = window.location.href;
                const step = fullPath?.split('#')[1];
                console.log(step);
                getVendorDetail(vendorPolicyId);
                navigate(
                    ROUTER?.POLICY?.VENDOR_PRIVACY +
                        `/${vendorPolicyId}#${step}`
                );
            } else {
                notify({
                    type: 'error',
                    title: t('common.Fail'),
                    description: t('common.FailedSaveData'),
                });
            }
        } catch (error) {
            console.log(error);
            notify({
                type: 'error',
                title: t('common.Fail'),
                description: t('common.FailedSaveData'),
            });
        }
    };

    const calProgress = () => {
        const dsTypeList = [];
        vendorPrivacyPolicy
            ?.getFieldValue('vendorPrivacyPolicyDataSubjectType')
            ?.forEach((val) => {
                const item = dsType?.filter((res) => res?.value === val)[0];
                dsTypeList?.push({
                    vendorPrivacyPolicyDataSubjectTypeId:
                        editData?.vendorPrivacyPolicyDataSubjectTypeId,
                    vendorDataSubjectId: item?.value,
                    vendorDataSubjectNameTh: item?.title,
                    vendorDataSubjectNameEn: item?.title,
                });
            });
        const display = preview?.getFieldsValue();
        setSubmitData({
            vendorPrivacyPolicy: {
                ...submitData?.vendorPrivacyPolicy,
                ...vendorPrivacyPolicy?.getFieldsValue(),
                vendorPrivacyPolicyId: editData?.vendorPrivacyPolicyId,
                vendorPrivacyPolicyDataSubjectType: dsTypeList,
                vendorEffectiveDate: vendorPrivacyPolicy
                    ?.getFieldValue('vendorEffectiveDate')
                    ?.format('DD/MM/YYYY'),
                isPublish: false,
            },
            vendorIntroductionLawfulBasis: {
                ...submitData?.vendorIntroductionLawfulBasis,
                ...vendorIntroductionLawfulBasis?.getFieldsValue(),
                vendorIntroductionLawfulBasisId:
                    editData?.vendorIntroductionLawfulBasisId,
                vendorIntroductionIsDisplay:
                    display?.vendorIntroductionIsDisplay,
                vendorLawfulBasisIsDisplay: display?.vendorLawfulBasisIsDisplay,
            },
            vendorPersonalDataCollect: {
                ...submitData?.vendorPersonalDataCollect,
                ...vendorPersonalDataCollect?.getFieldsValue(),
                vendorPersonalDataCollectId:
                    editData?.vendorPersonalDataCollectId,
                vendorPersonalDataIsDisplay:
                    display?.vendorPersonalDataIsDisplay,
                vendorSourceIsDisplay: display?.vendorSourceIsDisplay,
            },
            vendorReasonCollectedData: {
                ...submitData?.vendorReasonCollectedData,
                ...vendorReasonCollectedData?.getFieldsValue(),
                vendorReasonCollectedDataId:
                    editData?.vendorReasonCollectedDataId,
                vendorPurposeIsDisplay: display?.vendorPurposeIsDisplay,
            },
            vendorTransferPersonalData: {
                ...submitData?.vendorTransferPersonalData,
                ...vendorTransferPersonalData?.getFieldsValue(),
                vendorTransferPersonalDataId:
                    editData?.vendorReasonCollectedDataId,
                vendorDisclosureIsDisplay: display?.vendorDisclosureIsDisplay,
                vendorInternationalIsDisplay:
                    display?.vendorInternationalIsDisplay,
            },
            vendorRetainPersonalData: {
                ...submitData?.vendorRetainPersonalData,
                ...vendorRetainPersonalData?.getFieldsValue(),
                vendorRetainPersonalDataId:
                    editData?.vendorRetainPersonalDataId,
                vendorRetentionIsDisplay: display?.vendorRetentionIsDisplay,
                vendorSecurityIsDisplay: display?.vendorSecurityIsDisplay,
            },
            vendorDataSubjectRight: {
                ...submitData?.vendorDataSubjectRight,
                ...vendorDataSubjectRight?.getFieldsValue(),
                vendorDataSubjectRightId: editData?.vendorDataSubjectRightId,
                vendorDataSubjectRightIsDisplay:
                    display?.vendorDataSubjectRightIsDisplay,
            },
            vendorPolicyChange: {
                ...submitData?.vendorPolicyChange,
                ...vendorPolicyChange?.getFieldsValue(),
                vendorPolicyChangeId: editData?.vendorPolicyChangeId,
                vendorChangeIsDisplay: display?.vendorChangeIsDisplay,
                vendorDataControllerIsDisplay:
                    display?.vendorDataControllerIsDisplay,
                vendorDataProtectionIsDisplay:
                    display?.vendorDataProtectionIsDisplay,
            },
        });
        if (!editMode) {
            // setCurrentProgress(number);
            setLoading(false);
        }
    };
    return (
        <Fragment>
            <div className="title flex items-center">
                <div
                    className="cursor-pointer mr-3 space-x-2"
                    onClick={() => {
                        navigate(
                            `${ROUTER.POLICY.DEFAULT}?tab=${POLICY_NAME.VENDOR_POLICY}`
                        );
                        // ${PRIVACY_NAME_BY_ID[_tab.policyTypeId]}
                    }}
                >
                    <IconBack />
                    <span>
                        {id === 'new'
                            ? t('Add Vendor Privacy Policy', {
                                  ns: 'hr-policy',
                              })
                            : t('Edit Vendor Privacy Policy', {
                                  ns: 'hr-policy',
                              })}
                    </span>
                </div>
            </div>
            <div className="sub-title">
                <span className="text-sm text-gray-400">
                    {t('Privacy')} / {t('Vendor Privacy Policy')} /{' '}
                </span>
                <span>
                    {id === 'new'
                        ? t('Add Vendor Privacy Policy', { ns: 'hr-policy' })
                        : t('Edit Vendpr Privacy Policy', { ns: 'hr-policy' })}
                </span>
            </div>
            <div className="mt-4 grid grid-cols-4 gap-4">
                {currentSelectList !== 9 && (
                    <StepList
                        steps={{
                            step1,
                            step2,
                            step3,
                            step4,
                            step5,
                            step6,
                            step7,
                            step8,
                        }}
                        setCurrentSelectList={() => {
                            // cannot move sp5
                        }}
                        SW={state?.SW}
                        currentSelectList={currentSelectList}
                        data={data}
                        setFixed={setFixed}
                    />
                )}
                <div
                    className={classNames({
                        'col-span-3': currentSelectList !== 9,
                        'col-span-4': currentSelectList === 9,
                    })}
                >
                    {currentSelectList !== 9 && (
                        <div className="bg-white rounded-md p-4 flex font-semibold text-base">
                            <div className="flex-1 -mt-0.5">
                                <Progress
                                    strokeColor={{
                                        '0%': '#4ACE8F',
                                        '100%': '#4ACE8F',
                                    }}
                                    percent={currentProgress}
                                    status="active"
                                    showInfo={false}
                                />
                            </div>
                            <span
                                className={`pl-6 pr-2 ${
                                    currentProgress === 0
                                        ? 'text-red-500'
                                        : 'text-green-400'
                                }`}
                            >
                                {currentProgress}% {t('succeed')}
                            </span>

                            <span>{t('filledinformation')}</span>
                        </div>
                    )}
                    <Provider
                        onFormChange={onFormChange}
                        onFormFinish={onFormFinish}
                    >
                        <div className="mt-4 bg-white rounded-md p-4 overflow-hidden">
                            <StepWizard
                                isHashEnabled
                                instance={setInstance}
                                onStepChange={(e) => {
                                    setCurrentSelectList(e.activeStep);
                                }}
                            >
                                <Step1
                                    loading={loading_}
                                    editMode={editMode}
                                    saveDraft={saveDraft}
                                    applications={applications}
                                    setApplications={setApplications}
                                    form={vendorPrivacyPolicy}
                                    calProgress={calProgress}
                                    setStep1={setStep1}
                                    step1={step1}
                                    editData={editData}
                                    dsType={dsType}
                                />
                                <Step2
                                    loading={loading_}
                                    editMode={editMode}
                                    saveDraft={saveDraft}
                                    applications={applications}
                                    setApplications={setApplications}
                                    form={vendorIntroductionLawfulBasis}
                                    calProgress={calProgress}
                                    setStep2={setStep2}
                                    step2={step2}
                                    editData={editData}
                                />
                                <Step3
                                    loading={loading_}
                                    editMode={editMode}
                                    saveDraft={saveDraft}
                                    applications={applications}
                                    setApplications={setApplications}
                                    form={vendorPersonalDataCollect}
                                    calProgress={calProgress}
                                    setStep3={setStep3}
                                    step3={step3}
                                    editData={editData}
                                />
                                <Step4
                                    loading={loading_}
                                    editMode={editMode}
                                    saveDraft={saveDraft}
                                    applications={applications}
                                    setApplications={setApplications}
                                    form={vendorReasonCollectedData}
                                    calProgress={calProgress}
                                    setStep4={setStep4}
                                    step4={step4}
                                    editData={editData}
                                />
                                <Step5
                                    loading={loading_}
                                    editMode={editMode}
                                    saveDraft={saveDraft}
                                    applications={applications}
                                    setApplications={setApplications}
                                    form={vendorTransferPersonalData}
                                    calProgress={calProgress}
                                    setStep5={setStep5}
                                    step5={step5}
                                    editData={editData}
                                />
                                <Step6
                                    loading={loading_}
                                    editMode={editMode}
                                    saveDraft={saveDraft}
                                    applications={applications}
                                    setApplications={setApplications}
                                    form={vendorRetainPersonalData}
                                    calProgress={calProgress}
                                    setStep6={setStep6}
                                    step6={step6}
                                    editData={editData}
                                />
                                <Step7
                                    loading={loading_}
                                    editMode={editMode}
                                    saveDraft={saveDraft}
                                    applications={applications}
                                    setApplications={setApplications}
                                    form={vendorDataSubjectRight}
                                    calProgress={calProgress}
                                    setStep7={setStep7}
                                    step7={step7}
                                    editData={editData}
                                />
                                <Step8
                                    loading={loading_}
                                    editMode={editMode}
                                    saveDraft={saveDraft}
                                    form={vendorPolicyChange}
                                    calProgress={calProgress}
                                    passStep={passStep}
                                    setStep8={setStep8}
                                    step8={step8}
                                    editData={editData}
                                />
                                <StepPreview
                                    saveDraft={saveDraft}
                                    form={preview}
                                    loading_={loading_}
                                    loading={loading}
                                    applications={applications}
                                    data={submitData}
                                    calProgress={calProgress}
                                    privacyNoticeId={id}
                                    editData={editData}
                                    onFormFinish={onFormFinish}
                                />
                            </StepWizard>
                        </div>
                    </Provider>
                </div>
            </div>
            <ModalDiscardChanges
                open={openChange}
                handelOk={isChangeLocation ? handelOkLocation : handelOk}
                handelClose={() => setOpenChange(false)}
            />
        </Fragment>
    );
}
